import { DnaIcon } from './DnaIcon';

/**
 * author: Haley Halcyon
 * id 2C726E7E-53C8-410C-82F4-FE5DE9EF4BC1
 * name dna
 * version: 1.7.12
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/dna.svg
 * tags
 * - Science 
 */
export const HelixIcon = DnaIcon;
export default HelixIcon